module.exports = __webpack_public_path__ + "assets/media/stars.0cac1231.svg";